import { Checkbox } from "antd";
import React, { useState } from "react";

export default function AntCheckBox({
	item,
	activeInput,
	readOnly,
	addData,
	setSubmitData,
	submitData,
}) {
	const [value, setValue] = useState(false);
	// onChange below stores a real boolean, while a submission loaded back from the API
	// carries the string "true" - both have to read as checked or the box never ticks.
	const submittedValue = submitData?.find((i) => i.key === item.key)?.value;
	const currentValue = addData
		? submittedValue === true || submittedValue === "true"
		: item?.value ?? value ?? "";
	return (
		<div style={item?.css}>
			<Checkbox
				key={activeInput}
				className="form-label"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
				onChange={(e) => {
					setValue(!value);
					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: !value,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				checked={currentValue}
				value={currentValue}
				disabled={readOnly}
			>
				{item?.title}
			</Checkbox>
		</div>
	);
}
